<template>
  <div class="tuolele-main-box">
    <div class="app-container app-margin-bottom20">
      <el-form ref="postForm" label-width="100px" style="width:60%" :model="tyyPackage" :rules="rules">
        <el-form-item label="*套餐名称" prop="item_title">
          <el-input v-model="tyyPackage.item_title" placeholder="请输入套餐名称" />
        </el-form-item>
        <el-form-item label="*套餐类型" prop="item_type">
          <Select key="9" :selected.sync="tyyPackage.item_type" :data="packageTypes" clearable placeholder="请选择" />
        </el-form-item>
        <el-form-item label="*套餐科目" prop="subject_id">
          <Select key="5" :selected.sync="tyyPackage.subject_id" :data="subjectLists" clearable placeholder="请选择" />
        </el-form-item>
        <el-form-item label="*有效天数" prop="effective_day">
          <el-input v-model="tyyPackage.effective_day" placeholder="请输入有效天数" type="number" />
        </el-form-item>
        <el-form-item label="*套餐价格" prop="total_price">
          <el-input v-model="tyyPackage.total_price" placeholder="请输入套餐价格" type="number" />
        </el-form-item>
        <el-form-item label="*适用年级" prop="grade_id">
          <el-checkbox-group v-model="gradeCheckLists">
            <el-checkbox v-for="item in gradeLists" :key="'grade_'+item.id" :label="item.id">{{ item.name }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <h1 style="color:#666666;padding-left: 7px;margin-bottom: 10px;">退款信息</h1>
        <el-form-item label="*是否可退">
          <el-radio v-model="tyyPackage.can_refund" label="1">可退</el-radio>
          <el-radio v-model="tyyPackage.can_refund" label="0">不可退</el-radio>
        </el-form-item>
        <el-form-item label="*退费规则">
          <div>
            课时消耗
            <el-input v-model="tyyPackage.refund_days" style="display: inline-block;width:90px" placeholder="" type="number" />
            天内，可退
            <el-input v-model="tyyPackage.refund_price" style="display: inline-block;width:90px" placeholder="" type="number" />
            元
          </div>
        </el-form-item>
        <el-button type="primary" @click="fnSubmitForm">提交</el-button>
      </el-form>
    </div>

  </div>
</template>

<script>

import Select from '@/components/Select'
import { validateRequire } from '@/utils/validate'
import commondata from '@/utils/commondata'

// import TeachingTypeSelect from '@/components/Select/TeachingTypeSelect'

export default {
  components: {
    Select
  },
  data() {
    return {
      tyyPackage: {
        item_title: '',
        subject_id: '',
        grade_id: '',
        total_price: '',
        item_type: '',
        can_refund: '1',
        refund_price: '',
        refund_days: ''
      },
      gradeCheckLists: [],
      subjectLists: commondata.TYY_SUBJECT_LISTS,
      packageTypes: commondata.TYY_PACKAGE_TYPE,
      gradeLists: commondata.GRADE_LISTS,

      rules: {
        item_title: [{ validator: validateRequire, trigger: 'manual', message: '套餐名称' }],
        subject_id: [{ validator: validateRequire, trigger: 'manual', message: '套餐科目' }],
        grade_id: [{ validator: validateRequire, trigger: 'manual', message: '适合年级' }],
        total_price: [{ validator: validateRequire, trigger: 'manual', message: '套餐价格' }],
        item_type: [{ validator: validateRequire, trigger: 'manual', message: '套餐类型' }],
        effective_day: [{ validator: validateRequire, trigger: 'manual', message: '有效天数' }]
      }
    }
  },
  watch: {
    gradeCheckLists(newVal, oldVal) {
      this.tyyPackage.grade_id = (newVal || []).join(',')
    }
  },
  created() {

  },
  methods: {
    // 提交
    fnSubmitForm: function() {
      if (this.tyyPackage.can_refund == '1') {
        if (!this.tyyPackage.refund_days || !this.tyyPackage.refund_price) {
          this.$message.error('请填写退款信息')
          return
        }
      }
      this.$refs.postForm.validate(valid => {
        if (valid) {
          this.$http.tyyImproveItem(this.tyyPackage).then(res => {
            this.$message({
              type: 'success',
              message: '操作成功!'
            })
            setTimeout(this.$router.push({ path: '/admin/tiyouyou/tiyouyouPackageList' }), 2000)
          })
        }
      })
    }

  }
}
</script>

<style lang="scss" >

</style>
